module.exports = __webpack_public_path__ + "static/img/pic_coop02@2x.27cc3b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/anchorOperation/skillsTaining/pic_coop02@2x.png
// module id = c19t
// module chunks = 0